'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTagsinput = require('react-tagsinput');

var _reactTagsinput2 = _interopRequireDefault(_reactTagsinput);

var _reactAutosuggest = require('react-autosuggest');

var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

var _TagsInputOptions = require('./TagsInputOptions');

var _TagsInputOptions2 = _interopRequireDefault(_TagsInputOptions);

var _utilities = require('../utilities');

var _utilities2 = _interopRequireDefault(_utilities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TagsInputAutocomplete = function (_React$Component) {
  _inherits(TagsInputAutocomplete, _React$Component);

  _createClass(TagsInputAutocomplete, null, [{
    key: '_getSuggestionValue',
    value: function _getSuggestionValue(suggestion) {
      var span = document.createElement('span');
      span.innerHTML = suggestion;
      return span.innerText;
    }
  }, {
    key: '_handleRenderSuggestion',
    value: function _handleRenderSuggestion(suggestion) {
      return _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: suggestion } });
    }
  }, {
    key: '_handleShouldRenderSuggestions',
    value: function _handleShouldRenderSuggestions(value) {
      return value && value.trim().length > 0;
    }
  }, {
    key: 'renderTag',
    value: function renderTag(props) {
      var tag = props.tag,
          key = props.key,
          disabled = props.disabled,
          onRemove = props.onRemove,
          classNameRemove = props.classNameRemove,
          getTagDisplayValue = props.getTagDisplayValue,
          other = _objectWithoutProperties(props, ['tag', 'key', 'disabled', 'onRemove', 'classNameRemove', 'getTagDisplayValue']);

      return _react2.default.createElement(
        'span',
        _extends({ key: key }, other),
        _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: getTagDisplayValue(tag) } }),
        !disabled && _react2.default.createElement('a', { className: classNameRemove, onClick: function onClick(e) {
            return onRemove(key);
          } })
      );
    }
  }]);

  function TagsInputAutocomplete(props) {
    _classCallCheck(this, TagsInputAutocomplete);

    var _this = _possibleConstructorReturn(this, (TagsInputAutocomplete.__proto__ || Object.getPrototypeOf(TagsInputAutocomplete)).call(this, props));

    _this._handleOnSuggestionsFetchRequested = _this._handleOnSuggestionsFetchRequested.bind(_this);
    _this._handleOnSuggestionsClearRequested = _this._handleOnSuggestionsClearRequested.bind(_this);
    _this._handleRenderLayout = _this._handleRenderLayout.bind(_this);
    _this._handleOptionsOnClick = _this._handleOptionsOnClick.bind(_this);
    _this._handleFetchData = _this._handleFetchData.bind(_this);
    _this.focus = _this.focus.bind(_this);

    _this._handleOnSuggestionsFetchRequested = (0, _utilities2.default)(_this._handleOnSuggestionsFetchRequested, props.debounceIntervalMs);

    _this.state = {
      suggestions: _this.props.suggestions.slice(0, _this.props.maxSuggestions)
    };
    return _this;
  }

  _createClass(TagsInputAutocomplete, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var suggestions = nextProps.suggestions,
          maxSuggestions = nextProps.maxSuggestions;


      this.setState({
        suggestions: suggestions.slice(0, maxSuggestions)
      });
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.autocomplete.input.focus();
    }
  }, {
    key: '_handleFetchData',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(searchString) {
        var _props, maxTags, fetchData, extractData, results, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, maxTags = _props.maxTags, fetchData = _props.fetchData, extractData = _props.extractData;
                _context.next = 3;
                return fetchData(searchString);

              case 3:
                results = _context.sent;
                data = extractData ? extractData(results) : results;

                if (data) {
                  _context.next = 8;
                  break;
                }

                this.setState({ suggestions: [] });
                return _context.abrupt('return');

              case 8:
                this.setState({ suggestions: data.slice(0, maxTags) });

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _handleFetchData(_x) {
        return _ref.apply(this, arguments);
      }

      return _handleFetchData;
    }()
  }, {
    key: '_handleOnSuggestionsFetchRequested',
    value: function _handleOnSuggestionsFetchRequested(e) {
      var _this2 = this;

      var _props2 = this.props,
          extractData = _props2.extractData,
          maxSearchLength = _props2.maxSearchLength,
          maxTags = _props2.maxTags,
          fetchData = _props2.fetchData;
      var url = this.props.url;

      var searchString = e.value.substring(0, maxSearchLength);

      if (url) {
        url = url.replace('{search}', searchString);

        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.onload = function () {
          if (request.status >= 200 && request.status < 400) {
            var resp = request.responseText;
            var data = extractData ? extractData(JSON.parse(resp)) : JSON.parse(resp);
            _this2.setState({ suggestions: data.slice(0, maxTags) });
          } else {
            _this2.setState({ suggestions: [] });
          }
        };

        request.onerror = function () {
          this.setState({ suggestions: [] });
        };

        request.send();
      } else if (fetchData && searchString) {
        this._handleFetchData(searchString);
      }
    }
  }, {
    key: '_handleOnSuggestionsClearRequested',
    value: function _handleOnSuggestionsClearRequested() {
      this.setState({
        suggestions: []
      });
    }
  }, {
    key: '_handleRenderLayout',
    value: function _handleRenderLayout(tagComponents, inputComponent) {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        {
          onClick: function onClick() {
            _this3.autocomplete.input.focus();
          }
        },
        tagComponents,
        inputComponent
      );
    }
  }, {
    key: '_handleOptionsOnClick',
    value: function _handleOptionsOnClick(uid, values) {
      var _props3 = this.props,
          onChange = _props3.onChange,
          value = _props3.value,
          maxTags = _props3.maxTags,
          id = _props3.id;

      var newValue = value.concat(values);

      if (maxTags === -1 || newValue.length <= maxTags) {
        onChange(id, newValue);
      }
    }
  }, {
    key: 'renderAutocompleteInput',
    value: function renderAutocompleteInput(args, props) {
      var _this4 = this;

      var addTag = props.addTag,
          onChange = props.onChange,
          other = _objectWithoutProperties(props, ['addTag', 'onChange']);

      var id = args.id,
          suggestions = args.suggestions,
          placeholder = args.placeholder,
          fetch = args.fetch,
          clear = args.clear,
          value = args.value,
          render = args.render,
          shouldRender = args.shouldRender;

      var handleOnChange = function handleOnChange(e, _ref2) {
        var newValue = _ref2.newValue,
            method = _ref2.method;

        if (method === 'enter') {
          e.preventDefault();
        } else {
          onChange(e);
        }
      };

      return _react2.default.createElement(_reactAutosuggest2.default, {
        id: id,
        suggestions: suggestions,
        onSuggestionsFetchRequested: fetch,
        onSuggestionsClearRequested: clear,
        getSuggestionValue: value,
        renderSuggestion: render,
        shouldRenderSuggestions: shouldRender,
        inputProps: _extends({}, other, { onChange: handleOnChange, placeholder: placeholder, id: id, autoComplete: 'off' }),
        onSuggestionSelected: function onSuggestionSelected(e, _ref3) {
          var suggestion = _ref3.suggestion;

          addTag(suggestion);
        },
        ref: function ref(ac) {
          _this4.autocomplete = ac;
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          value = _props4.value,
          onChange = _props4.onChange,
          id = _props4.id,
          inputLabelText = _props4.inputLabelText,
          className = _props4.className,
          placeholder = _props4.placeholder,
          maxTags = _props4.maxTags,
          addKeys = _props4.addKeys,
          tagProps = _props4.tagProps,
          tabIndex = _props4.tabIndex,
          optionsAbove = _props4.optionsAbove,
          optionsProps = _props4.optionsProps;

      var values = optionsProps.values,
          others = _objectWithoutProperties(optionsProps, ['values']);

      var suggestions = this.state.suggestions;

      var hasInputLabelText = inputLabelText && inputLabelText.length;
      var filteredOptions = values.filter(function (o) {
        return value.indexOf(o) === -1;
      });
      var hasValue = value.length;
      var stateClassName = hasValue ? '' : 'pxl-tagsinput-autocomplete--no-selection';

      var args = {
        id: id,
        suggestions: suggestions,
        placeholder: hasValue ? '' : placeholder,
        fetch: this._handleOnSuggestionsFetchRequested,
        clear: this._handleOnSuggestionsClearRequested,
        value: TagsInputAutocomplete._getSuggestionValue,
        render: TagsInputAutocomplete._handleRenderSuggestion,
        shouldRender: TagsInputAutocomplete._handleShouldRenderSuggestions
      };
      var options = _react2.default.createElement(_TagsInputOptions2.default, _extends({}, others, { id: id, options: filteredOptions, onChange: this._handleOptionsOnClick }));

      return _react2.default.createElement(
        'div',
        { className: 'pxl-tagsinput-autocomplete ' + className + ' ' + stateClassName },
        optionsAbove && options,
        hasInputLabelText && _react2.default.createElement(
          'label',
          { className: 'pxl-control-label', htmlFor: id },
          inputLabelText
        ),
        _react2.default.createElement(_reactTagsinput2.default, {
          value: value,
          onChange: onChange.bind(null, id),
          renderInput: this.renderAutocompleteInput.bind(this, args),
          addKeys: addKeys,
          onlyUnique: true,
          maxTags: maxTags,
          inputProps: {
            tabIndex: tabIndex
          },
          tagProps: _extends({}, tagProps, {
            classNameRemove: 'pxl-tag__remove'
          }),
          addOnBlur: true,
          renderTag: TagsInputAutocomplete.renderTag,
          renderLayout: this._handleRenderLayout
        }),
        !optionsAbove && options
      );
    }
  }]);

  return TagsInputAutocomplete;
}(_react2.default.Component);

exports.default = TagsInputAutocomplete;


TagsInputAutocomplete.propTypes = {
  addKeys: _propTypes2.default.array,
  className: _propTypes2.default.string,
  debounceIntervalMs: _propTypes2.default.number,
  extractData: _propTypes2.default.func,
  fetchData: _propTypes2.default.func,
  id: _propTypes2.default.string.isRequired,
  inputLabelText: _propTypes2.default.string,
  maxSearchLength: _propTypes2.default.number,
  maxSuggestions: _propTypes2.default.number,
  maxTags: _propTypes2.default.number,
  onChange: _propTypes2.default.func,
  optionsAbove: _propTypes2.default.bool,
  optionsProps: _propTypes2.default.shape({
    className: _propTypes2.default.string,
    initShown: _propTypes2.default.number,
    maxShown: _propTypes2.default.number,
    type: _propTypes2.default.oneOf(['none', 'checklist', 'pills']),
    values: _propTypes2.default.array
  }),
  placeholder: _propTypes2.default.string,
  suggestions: _propTypes2.default.array,
  tabIndex: _propTypes2.default.number,
  tagProps: _propTypes2.default.shape({
    className: _propTypes2.default.string
  }),
  url: _propTypes2.default.string,
  value: _propTypes2.default.array
};

TagsInputAutocomplete.defaultProps = {
  addKeys: [9, 13, 188],
  className: '',
  debounceIntervalMs: 100,
  inputLabelText: '',
  maxSearchLength: 50,
  maxSuggestions: 5,
  maxTags: -1,
  onChange: function onChange() {},

  optionsAbove: false,
  optionsProps: {
    values: []
  },
  suggestions: [],
  tabIndex: 0,
  tagProps: {
    className: 'pxl-pill pxl-pill--active'
  },
  url: '',
  value: []
};